import { render } from "./Textarea.vue?vue&type=template&id=6145c3e9&scoped=true&ts=true"
import script from "./Textarea.vue?vue&type=script&lang=ts"
export * from "./Textarea.vue?vue&type=script&lang=ts"

import "./Textarea.vue?vue&type=style&index=0&id=6145c3e9&lang=scss&scoped=true"
import "./Textarea.vue?vue&type=style&index=1&id=6145c3e9&lang=postcss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6145c3e9"]])

export default __exports__